var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from '../../../src/ts/framework/Framework';
import { Component } from '../../../src/ts/framework/Component';
import { FileUploader } from '../common/Uploader';
import Modal from 'bootstrap/js/dist/modal';
import { ImageCropper } from '../common/ImageCropper';
export class AutomaticIdentification extends Component {
    constructor() {
        super('AutomaticIdentification', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            this.refreshSessionID();
            const fileUploaderElement = $('.module-automatic-identification .hw-file-uploader');
            this.imageUploader = new FileUploader(fileUploaderElement, this._sessionID);
            fileUploaderElement.on('file-uploading', (event) => {
                $('.hw-submit-box y').addClass('d-none');
            });
            fileUploaderElement.on('file-updated', (event) => {
                if (event.data.fileCount > 0) {
                    $('.hw-submit-box ').removeClass('d-none');
                }
                else {
                    $('.hw-submit-box ').addClass('d-none');
                }
            });
            $('.module-automatic-identification-btn-identify').on('click', (event) => {
                event.preventDefault();
                this.identify();
            });
            $('body').on('click', '.module-automatic-identification-btn-reset', (event) => {
                event.preventDefault();
                this.reset();
            });
            $('body').on('click', '.hw-file-uploader-gallery-image-crop', (event) => {
                event.preventDefault();
                this.imageCropper.init($(event.target).data('originalFilename'));
                const modal = new Modal($('#modal-crop').get(0));
                modal.show();
            });
            this.imageCropper = new ImageCropper($('.crop-container'), this);
            $('.module-automatic-identification-btn-info').on('click', (event) => {
                event.preventDefault();
                const modal = new Modal($('#modal-notice').get(0));
                modal.show();
            });
            $('.language-selector a').on('click', (event, link) => {
                event.preventDefault();
                $('.language-selector a').removeClass('is-active');
                $(link).addClass('is-active');
                $('body').attr('data-lang', $(event.target).attr('href').replace('#', ''));
            });
            $('.hw-checkbox-terms input').on('change', (event) => {
                if ($('.hw-checkbox-terms input').get(0).checked) {
                    sessionStorage.setItem('terms_accepted', '1');
                    this.enableIdentifyButton();
                }
            });
            if (sessionStorage.getItem('terms_accepted') === '1')
                this.enableIdentifyButton();
            this.success();
        });
    }
    enableIdentifyButton() {
        $('.hw-checkbox-terms').addClass('d-none');
        $('.module-automatic-identification-btn-identify').removeClass('btn-disabled pe-none');
    }
    refreshSessionID() {
        this._sessionID = (new Date()).getTime().toString() + '-' + Math.random().toString(36).substring(2, 15);
        if (this.imageUploader)
            this.imageUploader.updateSessionID(this._sessionID);
    }
    get sessionID() {
        return this._sessionID;
    }
    identify() {
        return __awaiter(this, void 0, void 0, function* () {
            $('.module-automatic-identification-message-warning, .hw-file-uploader').addClass('d-none');
            $('.module-automatic-identification-loading').removeClass('d-none').addClass('d-flex');
            const response = yield $.httpRequest({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                body: {
                    action: 'automatic_identification_identify',
                    session_id: this._sessionID,
                    files: JSON.stringify(this.imageUploader.files),
                    use_gps: $('.hw-checkbox-use-gps input').get(0).checked ? 1 : 0,
                },
                dataType: 'html'
            });
            $('.module-automatic-identification-loading').removeClass('d-flex').addClass('d-none');
            $('.module-automatic-identification-results').removeClass('d-none');
            $('.module-automatic-identification-results').append(response);
        });
    }
    reset() {
        $('.module-automatic-identification-message-warning, .hw-file-uploader').removeClass('d-none');
        $('.module-automatic-identification-results, .hw-submit-box').addClass('d-none');
        $('.module-automatic-identification-results').empty();
        this.refreshSessionID();
        this.imageUploader.reset();
        $.scrollTo(0, 0);
    }
    updateImage(originalFilename, filename) {
        this.imageUploader.updateFile(originalFilename, filename);
    }
}
